import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=2df76641&"
import script from "./UserDetails.vue?vue&type=script&lang=ts&"
export * from "./UserDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports